import React, { useState } from 'react';
import { Button } from '@/components/ui/Buttons';
import { useModalManager } from '@/components/common/Modal';
import { useQuestionRubric } from './useQuestionRubric';
import RubricSelectModal from './RubricSelectModal';
import { IRubricModalQuestion, IRubricModalQuestionTranslation } from './AddRubricModal/AddRubricModal.types';
import AddRubricModal from './AddRubricModal';
import EditRubricCard from './EditRubricCard';

interface IAddRubricButtonProps {
  question: IRubricModalQuestion;
  translations: [IRubricModalQuestionTranslation<'en'>, IRubricModalQuestionTranslation<'es'>];
}

const AddRubricButton = ({ question, translations }: IAddRubricButtonProps) => {
  const [rubricType, setRubricType] = useState<'holistic' | 'analytic' | null>(null);
  const { close, isOpen, open } = useModalManager();
  const { close: closeAddModal, isOpen: isAddModalOpen, open: openAddModal } = useModalManager();

  const { data, isFetching } = useQuestionRubric({ questionId: question.id });

  if (isFetching) return null;
  if (data) return <EditRubricCard question={question} rubric={data} translations={translations} />;

  return (
    <>
      <Button small color="green" onClick={open}>Add Rubric</Button>
      <RubricSelectModal
        isOpen={isOpen}
        openAddModal={openAddModal}
        setRubricType={setRubricType}
        onClose={close}
      />
      <AddRubricModal
        analyticRubricSelected={rubricType === 'analytic'}
        holisticRubricSelected={rubricType === 'holistic'}
        isOpen={isAddModalOpen}
        question={question}
        translations={translations}
        onClose={closeAddModal}
      />
    </>
  );
};

export default AddRubricButton;
